import { produce } from 'immer'
import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import type { IFilterSet } from '../../typings'
import { FilterIdList } from '../../typings'

export const useHandlers = <U, T extends IFilterSet<U>>(clearedFilters: T) => {
  const { submitForm, setValues } = useFormikContext<T>()

  const clearAll = useCallback(() => {
    setValues(clearedFilters)
    submitForm()
  }, [clearedFilters, setValues, submitForm])

  const onDeleteChip = useCallback(
    (filterId: string) => {
      setValues((values) =>
        produce(values, (draft) => {
          if (
            filterId == FilterIdList.SalesFunnelId &&
            clearedFilters.filters[FilterIdList.SalesFunnelStageId]
          ) {
            draft.filters[FilterIdList.SalesFunnelStageId].value =
              clearedFilters.filters[FilterIdList.SalesFunnelStageId].value
          }
          draft.filters[filterId].value = clearedFilters.filters[filterId].value
        }),
      )
      submitForm()
    },
    [clearedFilters.filters, setValues, submitForm],
  )

  return { clearAll, onDeleteChip }
}
